export var CustomerType;
(function (CustomerType) {
    CustomerType[CustomerType["FLS"] = 'fls'] = "FLS";
    CustomerType[CustomerType["MCS"] = 'mcs'] = "MCS";
})(CustomerType || (CustomerType = {}));
